// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { protectionApi } from '../apis/protection.api';

// action
import { actions } from '../actions/protection.action';
import { ResultBaseProps } from 'modules/common';
import { ReqCreateProtection, ResLastProtections, ResProtections } from '../model/protection.model';

/**
 * 작업자 보호구 등록
 */
export const createProtection = createAsyncThunk<ResultBaseProps, ReqCreateProtection>(
  actions.CREATE_PROTECTION,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await protectionApi.createProtection(data);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 작업자 보호구 조회
 */
export const getProtections = createAsyncThunk<ResProtections, string>(
  actions.GET_PROTECTION_LIST,
  async (workerId, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await protectionApi.getProtection(workerId);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 작업자 최신 보호구 조회
 */
export const getLastProtections = createAsyncThunk<ResLastProtections, string>(
  actions.GET_PROTECTION_LAST,
  async (workerId, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await protectionApi.getProtectionLast(workerId);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 작업자 보호구 삭제
 */
export const deleteProtection = createAsyncThunk<ResultBaseProps, string>(
  actions.DELETE_PROTECTION,
  async (workerId, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await protectionApi.deleteProtection(workerId);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
